module.exports = __webpack_public_path__ + "static/img/rectangle02.dfcc7cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/rectangle/rectangle02.jpg
// module id = k63D
// module chunks = 0